module.exports = __webpack_public_path__ + "img/kimo_pen.743d232f.svg";